module.exports = __webpack_public_path__ + "static/media/TacticVideo.98c083bf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TacticVideo.mp4
// module id = 70
// module chunks = 0